import React from 'react'
import Plus from '../icons/Plus'
import { useState } from 'react'
import Modal from './Modal'
import AddImageModal from './AddImageModal'

const AddImageButton = () => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <>
      <div
        className="bg-slateGray px-4 py-2 rounded-md flex items-center gap-1 cursor-pointer"
        onClick={() => setIsOpen(true)}>
        <div className="text-white w-5 h-5">
          <Plus />
        </div>
        <div className="text-14 font-semibold text-white">Add image</div>
      </div>
      <Modal isOpen={isOpen} toggleModal={() => setIsOpen(!isOpen)}>
        <AddImageModal onClose={() => setIsOpen(false)} />
      </Modal>
    </>
  )
}

export default AddImageButton
